/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NftOwnership } from './NftOwnership';
import {
    NftOwnershipFromJSON,
    NftOwnershipFromJSONTyped,
    NftOwnershipToJSON,
    NftOwnershipToJSONTyped,
} from './NftOwnership';

/**
 * 
 * @export
 * @interface GetUserRedeemableNftOwnershipsResponse
 */
export interface GetUserRedeemableNftOwnershipsResponse {
    /**
     * 
     * @type {Array<NftOwnership>}
     * @memberof GetUserRedeemableNftOwnershipsResponse
     */
    lootboxes: Array<NftOwnership>;
    /**
     * 
     * @type {Array<NftOwnership>}
     * @memberof GetUserRedeemableNftOwnershipsResponse
     */
    xpMultipliers: Array<NftOwnership>;
    /**
     * 
     * @type {string}
     * @memberof GetUserRedeemableNftOwnershipsResponse
     */
    xpMultiplierNftTrackerId: string;
}

/**
 * Check if a given object implements the GetUserRedeemableNftOwnershipsResponse interface.
 */
export function instanceOfGetUserRedeemableNftOwnershipsResponse(value: object): value is GetUserRedeemableNftOwnershipsResponse {
    if (!('lootboxes' in value) || value['lootboxes'] === undefined) return false;
    if (!('xpMultipliers' in value) || value['xpMultipliers'] === undefined) return false;
    if (!('xpMultiplierNftTrackerId' in value) || value['xpMultiplierNftTrackerId'] === undefined) return false;
    return true;
}

export function GetUserRedeemableNftOwnershipsResponseFromJSON(json: any): GetUserRedeemableNftOwnershipsResponse {
    return GetUserRedeemableNftOwnershipsResponseFromJSONTyped(json, false);
}

export function GetUserRedeemableNftOwnershipsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserRedeemableNftOwnershipsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'lootboxes': ((json['lootboxes'] as Array<any>).map(NftOwnershipFromJSON)),
        'xpMultipliers': ((json['xpMultipliers'] as Array<any>).map(NftOwnershipFromJSON)),
        'xpMultiplierNftTrackerId': json['xpMultiplierNftTrackerId'],
    };
}

export function GetUserRedeemableNftOwnershipsResponseToJSON(json: any): GetUserRedeemableNftOwnershipsResponse {
    return GetUserRedeemableNftOwnershipsResponseToJSONTyped(json, false);
}

export function GetUserRedeemableNftOwnershipsResponseToJSONTyped(value?: GetUserRedeemableNftOwnershipsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lootboxes': ((value['lootboxes'] as Array<any>).map(NftOwnershipToJSON)),
        'xpMultipliers': ((value['xpMultipliers'] as Array<any>).map(NftOwnershipToJSON)),
        'xpMultiplierNftTrackerId': value['xpMultiplierNftTrackerId'],
    };
}

